export const STRATEGY_STATUS = {
    ON_TRACK: "ON_TRACK",
    AT_RISK: "AT_RISK",
    OFF_TRACK: "OFF_TRACK",
    UNKNOWN: "UNKNOWN",
};

export const STRATEGY_STATUS_COLORS = {
    [STRATEGY_STATUS.ON_TRACK]: "#10B981",
    [STRATEGY_STATUS.AT_RISK]: "#F43F5E",
    [STRATEGY_STATUS.OFF_TRACK]: "#BA1A1A",
    [STRATEGY_STATUS.UNKNOWN]: "var(--surface-400)",
};

export function normalizeStrategyStatus(status) {
    const normalizedStatus = String(status || "")
        .trim()
        .replace(/[_\s]+/g, "-")
        .toLowerCase();

    if ([
        "on-way",
        "on-track",
        "in-progress",
        "healthy",
        "done",
        "completed",
        "achieved",
    ].includes(normalizedStatus)) {
        return STRATEGY_STATUS.ON_TRACK;
    }

    if ([
        "has-risks",
        "at-risk",
        "atrisk",
        "risk",
        "warning",
    ].includes(normalizedStatus)) {
        return STRATEGY_STATUS.AT_RISK;
    }

    if ([
        "out-of-way",
        "off-track",
        "offtrack",
        "blocked",
        "failed",
        "archived",
    ].includes(normalizedStatus)) {
        return STRATEGY_STATUS.OFF_TRACK;
    }

    return STRATEGY_STATUS.UNKNOWN;
}

export function getStrategyStatusColor(status) {
    return STRATEGY_STATUS_COLORS[normalizeStrategyStatus(status)];
}

export function withAlpha(color, alpha) {
    if (!color?.startsWith("#")) return color;

    const normalizedHex = color.replace("#", "");
    const isShortHex = normalizedHex.length === 3;
    const hex = isShortHex
        ? normalizedHex.split("").map(value => value + value).join("")
        : normalizedHex;

    const red = parseInt(hex.slice(0, 2), 16);
    const green = parseInt(hex.slice(2, 4), 16);
    const blue = parseInt(hex.slice(4, 6), 16);

    return `rgba(${red}, ${green}, ${blue}, ${alpha})`;
}
